'use strict';

module.exports = {
    path: {
        resume: '/public/resume.json'
    },

    navigation: {
        home: 'Home',
        about: 'About',
        // resume: 'Resume',
        work: 'Work',
        education: 'Education',
        skill: 'Skills',
        //portfolio: 'Portfolio',
        testimonials: 'References'
        // contact: 'Contact'
    },

    // portfolio: {
    //     image: {
    //         'Campus Guiding System': {
    //             thumb: 'public/images/portfolio/thumb/others.jpg',
    //             modal: 'public/images/portfolio/modal/others.png'
    //         },
    //         TweetIndex: {
    //             thumb: 'public/images/portfolio/thumb/tweetindex.jpg',
    //             modal: 'public/images/portfolio/modal/tweetindex.png'
    //         },
    //         'Heatmap Generator': {
    //             thumb: 'public/images/portfolio/thumb/mohk.jpg',
    //             modal: 'public/images/portfolio/modal/mohk.png'
    //         },
    //         zerohm: {
    //             thumb: 'public/images/portfolio/thumb/sbginfosys.jpg',
    //             modal: 'public/images/portfolio/modal/sbginfosys.jpg'
    //         },
    //         'vpdeva.github.io': {
    //             thumb: 'public/images/portfolio/thumb/vpdeva.jpg',
    //             modal: 'public/images/portfolio/modal/vpdeva.png'
    //         },
    //         'eslint-config-vpdeva': {
    //             thumb: 'public/images/portfolio/thumb/kamar.jpg',
    //             modal: 'public/images/portfolio/modal/kamar.png'
    //         },
    //         'load-directory': {
    //             thumb: 'public/images/portfolio/thumb/til.jpg',
    //             modal: 'public/images/portfolio/modal/til.png'
    //         },
    //         dockerfiles: {
    //             thumb: 'public/images/portfolio/thumb/iprocess.jpg',
    //             modal: 'public/images/portfolio/modal/iprocess.jpg'
    //         },
    //         SimpleSudoku: {
    //             thumb: 'public/images/portfolio/thumb/freelanceweb.jpg',
    //             modal: 'public/images/portfolio/modal/freelanceweb.png'
    //         }
    //     }
    // }
};



// WEBPACK FOOTER //
// ./app/config.js